import { PayloadAction } from "@reduxjs/toolkit";
import { ItemId } from "../../../../utl/models/ItemId";
import { GroupsState } from "../models/GroupsState";

const setNewItemId = (state: GroupsState, action: PayloadAction<ItemId>) => {
    state.newItemId = action.payload.id;
}

export default setNewItemId;